import script from "./UserAccounts.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAccounts.vue?vue&type=script&setup=true&lang=ts"

import "./UserAccounts.vue?vue&type=style&index=0&id=0aeda39c&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aeda39c"]])

export default __exports__